import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { OrderDocumentsRequestModel, OrderDocumentsResponseModel } from "@MasterBluePrint/Types/ApiModels";

const baseOrderDocumentsUrl = "/api/v1/orderDocuments/get";

export interface OrderDocumentsRequestApiParameter extends ApiParameter {
    orderDocumentsRequest: OrderDocumentsRequestModel;
}

export async function retrieveOrderDocuments(parameter: OrderDocumentsRequestApiParameter) {
    const uri = `${baseOrderDocumentsUrl}`;
    const orderDocumentsParameter = parameter.orderDocumentsRequest;
    const response = await post<OrderDocumentsRequestModel, OrderDocumentsResponseModel>(`${uri}`, orderDocumentsParameter);

    return response;
}

